import { ModalContent, Typography } from "@kyan/ui";

import { type PnlCardProps } from "#/types/pnlCard";

import { PnLCardGenerator } from "./PnLCardGenerator/PnLCardGenerator";

export const SharePnLModalContent: React.FC<PnlCardProps> = (props) => {
  return (
    <ModalContent exitDelay={0.1} className="px-8 pt-12 sm:min-w-135.75">
      <Typography
        grotesk
        primary
        element="h2"
        weight="medium"
        className="w-full text-left"
      >
        Share your PnL card
      </Typography>

      <PnLCardGenerator {...props} />
    </ModalContent>
  );
};
